import apiSlice from '../apiSlice';
import { GlobalFilterKeys } from '../types';
import { stripGlobalFilterKeys } from '../utils';

const DASHBOARD_API_URL = '/api';

import {
  MetricsData,
  normalizeMetricsData,
  RawMetricsData,
} from '@/features/dashboard';
import { TraffickingAdvertiserData } from '@/features/trafficking';
import { PaginationResponse } from '@/shared/utils/types';

const dashboardTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['metrics'],
});

const dashboardApiSlice = dashboardTags.injectEndpoints({
  endpoints: (builder) => ({
    getMetrics: builder.query<
      MetricsData,
      GlobalFilterKeys & { dateFrom: string; dateTo: string }
    >({
      query: (data) => ({
        url: `${DASHBOARD_API_URL}/metrics/`,
        method: 'POST',
        data: stripGlobalFilterKeys(data),
      }),
      transformResponse: (response: RawMetricsData) =>
        normalizeMetricsData(response),
    }),

    getAllAdvertisers: builder.query<
      TraffickingAdvertiserData[],
      GlobalFilterKeys
    >({
      query: () => ({
        url: `${DASHBOARD_API_URL}/algorithms/advertisers/`,
        method: 'GET',
        params: {
          page: 1,
          pageSize: 10000,
          all: true,
        },
      }),
      transformResponse: (
        response: PaginationResponse<TraffickingAdvertiserData>
      ) => response.results,
    }),
  }),
});

export const { useGetMetricsQuery, useGetAllAdvertisersQuery } =
  dashboardApiSlice;
